import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import userEvent from '@testing-library/user-event';

const inputStyle = {
  width: 250,
  margin: 5
}

class MagicEightBall extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      userInput: '',
      randomIndex: ''
    };
    this.ask = this.ask.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  ask(){
    if (this.state.userInput){
      this.setState({
        randomIndex: Math.floor(Math.random() * 20 + 1),
        userInput: ''
      });
    } else {
      this.setState({
        randomIndex: 0
      })
    }
  }

  handleChange(event){
    this.setState({
      userInput: event.target.value
    });
  }
  render(){
    const possibleAnswers = [
      'YOU HAVE TO ASK', //if the user don't ask but click the button
      'It is certain',
      'It is decidedly so',
      'Without a doubt',
      'Yes, definitely',
      'You may rely on it',
      'As I see it, yes',
      'Outlook good',
      'Yes',
      'Signs point to yes',
      'Reply hazy try again',
      'Ask again later',
      'Better not tell you now',
      'Cannot predict now',
      'Concentrate and ask again',
      "Don't count on it",
      'My reply is no',
      'My sources say no',
      'Most likely',
      'Outlook not so good',
      'Very doubtful'
    ];
    const answer = possibleAnswers[this.state.randomIndex];
    return (
      <div className='container'>
        <h1>Fontune teller here</h1>
        <input type="text" value={this.state.userInput} onChange={this.handleChange} style={inputStyle} /><br />
        <button onClick={this.ask}>Ask the Magic 8 Ball!</button>
        <br />
        <h3>Answer:</h3>
        <p style={{color: 'green'}}>
          {answer}
        </p>
      </div>
    )
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MagicEightBall />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
